import { View } from 'react-native';

import { useEstimatedPointsEarned } from '@fhs/loyalty/src/queries/loyalty.queries';
import { createMqStyles } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';

import { EstimatedPointsEarned } from '../../estimated-points-earned';

function EstimatedPointsRow() {
  const { serverOrderLoading } = useCartContext();

  const { data: estimatedPoints, isPending: isLoadingPoints, enabled } = useEstimatedPointsEarned();
  const styles = useMqStyles();

  const isLoading = isLoadingPoints || serverOrderLoading;

  if (!enabled || (!isLoading && !estimatedPoints)) {
    return null;
  }

  return (
    <View style={styles.container}>
      <EstimatedPointsEarned
        totalPointsEarned={estimatedPoints?.totalPointsEarned}
        isLoading={isLoading}
      />
    </View>
  );
}

export default EstimatedPointsRow;

const useMqStyles = createMqStyles({
  container: {
    $base: {
      paddingTop: 8,
      marginHorizontal: 28,
    },

  },
});
